import { gtagLineEvent } from "@/utils/gtag";

const LINE_URL = "https://lin.ee/ttCTp7T";
const GTAG_EVENT = "YAMEBI_1_LINE友達追加_仕組みセクション";

const steps = [
  {
    icon: "ri-bank-card-fill",
    title: "クレジットカード・スマホ決済と連携",
    desc: "普段使いの決済情報と連携し、購入履歴をリアルタイムで取得します。",
  },
  {
    icon: "ri-robot-fill",
    title: "AIが購入内容を監査",
    desc: "AIが購入内容を解析し、お菓子・ジャンクフード・甘いものなどやめたい品目を検出します。",
  },
  {
    icon: "ri-shield-check-fill",
    title: "設定条件に応じて「買えない環境」をつくる",
    desc: "条件に応じて購入をコントロール。我慢ではなく、環境の力で習慣を変えます。",
  },
];

export default function MechanismSection() {
  return (
    <section className="bg-[#F5F9F5] py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm text-[#00A000] font-bold tracking-widest uppercase mb-3">HOW IT WORKS</p>
          <h2 className="text-2xl md:text-3xl font-black text-[#1a1a1a] leading-tight">
            YAMEBIはどうやって<br />
            <span className="text-[#00B900]">「買えない環境」</span>をつくるのか
          </h2>
        </div>

        {/* 2カラム：ステップ + 画像 */}
        <div className="flex flex-col lg:flex-row items-center gap-10 mb-12">
          {/* 画像 */}
          <div className="w-full lg:w-[360px] h-[360px] flex-shrink-0 rounded-2xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/6feff2a2e12870cc396186dbe078b283.jpg"
              alt="スマートフォンで購入コントロールを確認している女性"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* ステップリスト */}
          <div className="flex-1 space-y-5">
            {steps.map((step, i) => (
              <div key={i} className="flex items-start gap-5 bg-white rounded-2xl p-6 border border-[#E0F0E0]">
                <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-[#E8F8E8] rounded-xl">
                  <i className={`${step.icon} text-2xl text-[#00B900]`}></i>
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs font-bold text-[#00A000] bg-[#E8F8E8] px-2 py-0.5 rounded-full">
                      STEP {i + 1}
                    </span>
                  </div>
                  <h3 className="text-[#1a1a1a] font-bold text-base mb-1">{step.title}</h3>
                  <p className="text-[#666] text-sm leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-[#1a1a1a] rounded-2xl p-8 text-center">
          <p className="text-white text-lg md:text-xl font-black leading-relaxed mb-6">
            つまりYAMEBIは、<br />
            <span className="text-[#66E066]">我慢して続ける制限ではなく、</span><br />
            <span className="text-[#66E066]">環境で続ける購入コントロール</span>を実現します。
          </p>
          <a
            href={LINE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => { e.preventDefault(); gtagLineEvent(LINE_URL, GTAG_EVENT); }}
            className="whitespace-nowrap inline-flex items-center gap-2 bg-[#00B900] hover:bg-[#009900] text-white font-bold text-base py-3 px-8 rounded-full transition-all cursor-pointer shadow-[0_8px_25px_rgba(0,185,0,0.5)] hover:shadow-[0_12px_35px_rgba(0,185,0,0.65)] hover:scale-105"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill text-lg"></i>
            </span>
            公式LINEを友だち追加
          </a>
          <p className="text-white/60 text-xs mt-2">まずはLINEで禁食の仕組みを確認</p>
        </div>
      </div>
    </section>
  );
}
